import { formatDateTime, formatDate } from './localeHelper';

export const twentyFourHrFormat = (value) => {
  return formatDateTime(value);
};

export const formatDateString = (value) => {
  return formatDate(value);
};

export const parseAndConvertToLocal = (reportedDate) => {
  try {
    if (!reportedDate) return null;
    let dateString = reportedDate;
    if (!dateString.includes('T') && !dateString.includes('Z') && !dateString.includes('+')) {
      dateString = dateString.replace(' ', 'T') + 'Z';
    }
    const dateTime = new Date(dateString);
    if (isNaN(dateTime.getTime())) return null;
    return dateTime;
  } catch {
    return null;
  }
};

export const convertMinutesToHoursAndMinutesShort = (totalMinutesString) => {
  if (!totalMinutesString || totalMinutesString === '' || totalMinutesString === 'null' || totalMinutesString === 'N/A') {
    return '0m';
  }
  const totalMinutes = parseInt(totalMinutesString);
  if (isNaN(totalMinutes) || totalMinutes <= 0) return '0m';
  const hours = Math.floor(totalMinutes / 60);
  const minutes = totalMinutes % 60;
  if (hours === 0) return `${minutes}m`;
  if (minutes === 0) return `${hours}h`;
  return `${hours}h ${minutes}m`;
};
